import axios from 'axios';

let prefix = "/shipping-rate"

const ShippingRateApi = {
	// ===== Shared Resources - Zones =====
	getZoneList(payload){
		return axios.get(prefix + "/zones/list", {params: payload})
	},
	getZoneById(id, payload){
		return axios.get(prefix + `/zones/get/${id}`, {params: payload})
	},
	createZone(payload){
		return axios.post(prefix + "/zones/create", payload)
	},
	updateZone(payload){
		return axios.post(prefix + "/zones/update", payload)
	},
	archiveZone(payload){
		return axios.post(prefix + "/zones/archive", payload)
	},

	// ===== SG Shipping - Country Zone Mappings =====
	getSgCountryZoneMappingList(payload){
		return axios.get(prefix + "/sg-shipping/country-zone-mappings/list", {params: payload})
	},
	getSgCountryZoneMappingById(id, payload){
		return axios.get(prefix + `/sg-shipping/country-zone-mappings/get/${id}`, {params: payload})
	},
	createSgCountryZoneMapping(payload){
		return axios.post(prefix + "/sg-shipping/country-zone-mappings/create", payload)
	},
	updateSgCountryZoneMapping(payload){
		return axios.post(prefix + "/sg-shipping/country-zone-mappings/update", payload)
	},
	archiveSgCountryZoneMapping(payload){
		return axios.post(prefix + "/sg-shipping/country-zone-mappings/archive", payload)
	},

	// ===== SG Shipping - Rates =====
	getSgRateList(payload){
		return axios.get(prefix + "/sg-shipping/rates/list", {params: payload})
	},
	getSgRateById(id, payload){
		return axios.get(prefix + `/sg-shipping/rates/get/${id}`, {params: payload})
	},
	createSgRate(payload){
		return axios.post(prefix + "/sg-shipping/rates/create", payload)
	},
	updateSgRate(payload){
		return axios.post(prefix + "/sg-shipping/rates/update", payload)
	},
	archiveSgRate(payload){
		return axios.post(prefix + "/sg-shipping/rates/archive", payload)
	},
	downloadSgRatesCsv(payload){
		return axios.get(prefix + "/sg-shipping/rates/download-csv", {params: payload, responseType: 'blob'})
	},
	uploadSgRatesCsv(payload){
		return axios.post(prefix + "/sg-shipping/rates/upload-csv", payload)
	},

	// ===== Third-Party Shipping - Regions =====
	getRegionList(payload){
		return axios.get(prefix + "/third-party-shipping/regions/list", {params: payload})
	},
	getRegionById(id, payload){
		return axios.get(prefix + `/third-party-shipping/regions/get/${id}`, {params: payload})
	},
	createRegion(payload){
		return axios.post(prefix + "/third-party-shipping/regions/create", payload)
	},
	updateRegion(payload){
		return axios.post(prefix + "/third-party-shipping/regions/update", payload)
	},
	archiveRegion(payload){
		return axios.post(prefix + "/third-party-shipping/regions/archive", payload)
	},

	// ===== Third-Party Shipping - Country Region Mappings =====
	getCountryRegionMappingList(payload){
		return axios.get(prefix + "/third-party-shipping/country-region-mappings/list", {params: payload})
	},
	getCountryRegionMappingById(id, payload){
		return axios.get(prefix + `/third-party-shipping/country-region-mappings/get/${id}`, {params: payload})
	},
	createCountryRegionMapping(payload){
		return axios.post(prefix + "/third-party-shipping/country-region-mappings/create", payload)
	},
	updateCountryRegionMapping(payload){
		return axios.post(prefix + "/third-party-shipping/country-region-mappings/update", payload)
	},
	archiveCountryRegionMapping(payload){
		return axios.post(prefix + "/third-party-shipping/country-region-mappings/archive", payload)
	},

	// ===== Third-Party Shipping - Region Zone Mappings =====
	getRegionZoneMappingList(payload){
		return axios.get(prefix + "/third-party-shipping/region-zone-mappings/list", {params: payload})
	},
	getRegionZoneMappingById(id, payload){
		return axios.get(prefix + `/third-party-shipping/region-zone-mappings/get/${id}`, {params: payload})
	},
	createRegionZoneMapping(payload){
		return axios.post(prefix + "/third-party-shipping/region-zone-mappings/create", payload)
	},
	updateRegionZoneMapping(payload){
		return axios.post(prefix + "/third-party-shipping/region-zone-mappings/update", payload)
	},
	archiveRegionZoneMapping(payload){
		return axios.post(prefix + "/third-party-shipping/region-zone-mappings/archive", payload)
	},

	// ===== Third-Party Shipping - Rates =====
	getThirdPartyRateList(payload){
		return axios.get(prefix + "/third-party-shipping/rates/list", {params: payload})
	},
	getThirdPartyRateById(id, payload){
		return axios.get(prefix + `/third-party-shipping/rates/get/${id}`, {params: payload})
	},
	createThirdPartyRate(payload){
		return axios.post(prefix + "/third-party-shipping/rates/create", payload)
	},
	updateThirdPartyRate(payload){
		return axios.post(prefix + "/third-party-shipping/rates/update", payload)
	},
	archiveThirdPartyRate(payload){
		return axios.post(prefix + "/third-party-shipping/rates/archive", payload)
	},
	downloadThirdPartyRatesCsv(payload){
		return axios.get(prefix + "/third-party-shipping/rates/download-csv", {params: payload, responseType: 'blob'})
	},
	uploadThirdPartyRatesCsv(payload){
		return axios.post(prefix + "/third-party-shipping/rates/upload-csv", payload)
	},

	// ===== Markup =====
	getMarkup(payload){
		return axios.get(prefix + "/markup/get", {params: payload})
	},
	updateMarkup(payload){
		return axios.post(prefix + "/markup/update", payload)
	},

	// ===== Calculate Shipping Rate =====
	calculateShippingRate(payload){
		return axios.post(prefix + "/calculate", payload)
	},
}

export default ShippingRateApi;
